import { CALL_API } from './../../middlewares/api';

const adicionaItem = ({ value, tipo }) => ({
  [CALL_API]: {
    type: 'CREATE_ACHADOS',
    endpoint: 'achados',
    authenticated: true,
    config: {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      method: 'POST',
      body: {
        tipo,
        MAX_FILE_SIZE: 2097152,
        ...value
      }
    }
  }
});

const onLoadItemsIfNeeded = () => ({
  [CALL_API]: {
    type: 'LIST_ACHADOS',
    endpoint: 'achados',
    authenticated: false,
    config: {
      method: 'GET'
    }
  }
});

const onLoadItems = () => (dispatch, getState) => {
  const achados = getState().achados;
  const { fetching, errors } = achados;
  if (!fetching && !errors.length) {
    return dispatch(onLoadItemsIfNeeded());
  }
  return Promise.resolve(achados);
};

const atualizaPessoa = ({ value, devolvido }) => ({
  [CALL_API]: {
    type: 'ATUALIZA_ITEM_ACHADOS',
    endpoint: 'achados',
    authenticated: true,
    config: {
      method: 'PUT',
      querystring: { id: value.id, devolvido },
      body: { value }
    }
  }
});

const atualizaSituacao = ({ value, observacao }) => ({
  [CALL_API]: {
    type: 'ATUALIZA_ITEM_ACHADOS',
    endpoint: 'achados',
    authenticated: true,
    config: {
      method: 'PUT',
      querystring: { id: value.id, devolvido: 1 },
      body: { value, observacao }
    }
  }
});

const denunciaItem = ({ value, observacao }) => ({
  [CALL_API]: {
    type: 'ATUALIZA_ITEM_ACHADOS',
    endpoint: 'achados',
    authenticated: true,
    config: {
      method: 'PUT',
      querystring: { id: value.id, devolvido: -1 },
      body: { value, observacao }
    }
  }
});

const onLoadHistoricoIfNeeded = value => ({
  [CALL_API]: {
    type: 'SELECT_HISTORICO_ITEM_ACHADOS',
    endpoint: 'achados',
    authenticated: false,
    config: {
      method: 'GET',
      querystring: { id: value.id, type: "historico" },
    }
  },
  value
});

const onLoadHistorico = value => dispatch => {
  if (!value.historico) {
    return dispatch(onLoadHistoricoIfNeeded(value));
  }
  return Promise.resolve(value.historico);
};

export default {
  onLoadHistorico,
  denunciaItem,
  atualizaSituacao,
  atualizaPessoa,
  adicionaItem,
  onLoadItems,
  onLoadItemsIfNeeded
}


// WEBPACK FOOTER //
// ./src/modules/achados/actions.js